import moment from 'moment';

export const duration = state => moment(new Date(0)).seconds(state.time).format('m:ss');
